import axios from 'axios';
import { getToken } from './auth';
import { compactQuotationPayload } from '../utils/documentItemPayload';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

// Create quotation
export const createQuotation = async (branchId, data) =>
  (await axios.post(
    `${API_URL}/branch/${branchId}/quotations`,
    compactQuotationPayload(data),
    withAuth()
  )).data;

// List quotations with optional filters
export const listQuotations = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/quotations`, { ...withAuth(), params })).data;

// List editable draft quotations for tabbed quotation editing
export const listOpenQuotations = async (branchId) =>
  listQuotations(branchId, {
    status: 'draft',
    isDeleted: false,
    pageSize: 0,
  });

// List quotations for a client
export const listQuotationsByClient = async (branchId, clientId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/quotations/client/${clientId}`, { ...withAuth(), params })).data;

// Get single quotation
export const getQuotationById = async (branchId, id) =>
  (await axios.get(`${API_URL}/branch/${branchId}/quotations/${id}`, withAuth())).data;

// Update quotation
export const updateQuotation = async (branchId, id, data) =>
  (await axios.patch(
    `${API_URL}/branch/${branchId}/quotations/${id}`,
    compactQuotationPayload(data),
    withAuth()
  )).data;

// Delete (soft delete)
export const deleteQuotation = async (branchId, id) =>
  (await axios.delete(`${API_URL}/branch/${branchId}/quotations/${id}`, withAuth())).data;

// Send quotation (email + mark sent)
export const sendQuotation = async (branchId, id, data = {}) =>
  (await axios.post(`${API_URL}/branch/${branchId}/quotations/${id}/send`, data, withAuth())).data;

// Duplicate quotation into new draft
export const duplicateQuotation = async (branchId, id) =>
  (await axios.post(`${API_URL}/branch/${branchId}/quotations/${id}/duplicate`, {}, withAuth())).data;

// Convert quotation to purchase (unpaid)
export const convertQuotationToPurchase = async (branchId, id, data = {}) =>
  (await axios.post(`${API_URL}/branch/${branchId}/quotations/${id}/convert-to-purchase`, data, withAuth())).data;
